import {
  CustomerAddressBlock,
  formatAmount,
  ASUInvoiceHeader,
  InvoiceInfoBlock,
  InvoiceItemsTable,
  InvoiceLayout,
  OrderDetailBatchReturnType,
  ASUInvoiceFooter,
} from './common';

const SGASUInvoice = ({ order }: { order: OrderDetailBatchReturnType }) => {
  const subTotal = order.payAmountActualCurrency || 0;
  const actualCurrencyRate = order.orderItems[0]?.actualCurrencyRate ?? 1;
  const integrationDeduction = order.useIntegration
    ? Math.round(order.useIntegration * actualCurrencyRate)
    : 0;
  const summaryRows = [
    order.freightAmountActualCurrency
      ? {
          label: 'Freight :',
          value: formatAmount(order.freightAmountActualCurrency),
        }
      : null,
    order.promotionAmountActualCurrency
      ? {
          label: 'Discount :',
          value: `-${formatAmount(order.promotionAmountActualCurrency)}`,
        }
      : null,
    integrationDeduction
      ? {
          label: 'Points Deduction :',
          value: `-${formatAmount(integrationDeduction)}`,
        }
      : null,
    {
      label: 'Sub Total Amount :',
      value: formatAmount(subTotal),
    },
  ].filter((row): row is { label: string; value: string } => Boolean(row));

  return (
    <InvoiceLayout>
      <ASUInvoiceHeader title="SALES INVOICE" />

      <section className="mb-[30px] flex items-start justify-between gap-6">
        <CustomerAddressBlock order={order} />
        <InvoiceInfoBlock order={order} invoiceNoLabel="Invoice No :" />
      </section>

      <InvoiceItemsTable order={order} />

      <section className="ml-auto mr-[6px] w-[330px] text-xs mb-[30px]">
        {summaryRows.map((row) => (
          <div
            className="grid grid-cols-[1fr_112px] gap-x-8 mb-2 last:mb-0"
            key={row.label}
          >
            <span className="text-right whitespace-nowrap">{row.label}</span>
            <span className="text-right tabular-nums">{row.value}</span>
          </div>
        ))}
      </section>

      <p className="text-sm font-bold text-center mb-[34px]">
        ITEMS SOLD CANNOT BE RETURNED OR EXCHANGED
      </p>

      <section className="text-xs leading-[1.8]">
        <div className="mb-[22px] font-bold leading-none">
          <p>
            The statement &apos;Goods are sold under GST Gross Margin Scheme.
          </p>
          <p>
            Both the seller and buyer cannot claim any input tax on the
            goods&apos;.
          </p>
        </div>

        <ASUInvoiceFooter />
      </section>
    </InvoiceLayout>
  );
};

export default SGASUInvoice;
